import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M10 10.5V11.25H10.6284L10.7384 10.6313L10 10.5ZM11 8.25L10.4664 7.72297C10.4572 7.73232 10.4482 7.74191 10.4394 7.75173L11 8.25ZM8 1V0.25V1ZM5 8.25L4.43944 8.74827H4.43944L5 8.25ZM6 10.5L5.26158 10.6313L5.37157 11.25H6V10.5ZM10 10.5L10.7384 10.6313C10.8576 9.96097 11.1512 9.20878 11.5606 8.74827L11 8.25L10.4394 7.75173C9.78211 8.49122 9.40908 9.53903 9.26158 10.3687L10 10.5ZM11 8.25L11.5336 8.77703C11.9531 8.35228 12.3122 7.75621 12.5661 7.15378C12.8197 6.55212 13 5.86903 13 5.25H12.25H11.5C11.5 5.60597 11.3886 6.08538 11.1839 6.57122C10.9794 7.05629 10.7136 7.47272 10.4664 7.72297L11 8.25ZM12.25 5.25H13C13 3.84088 12.4881 2.77503 11.639 1.81975L11.0784 2.31803L10.5179 2.8163C11.169 3.54886 11.5 4.27217 11.5 5.25H12.25ZM11.0784 2.31803L11.639 1.81975C10.7248 0.791249 9.24001 0.25 8 0.25V1V1.75C8.88172 1.75 9.93181 2.15698 10.5179 2.8163L11.0784 2.31803ZM8 1V0.25C6.75999 0.25 5.27524 0.791249 4.36102 1.81975L4.92157 2.31803L5.48213 2.8163C6.06819 2.15698 7.11828 1.75 8 1.75V1ZM4.92157 2.31803L4.36102 1.81975C3.51189 2.77503 3 3.84088 3 5.25H3.75H4.5C4.5 4.27217 4.83097 3.54886 5.48213 2.8163L4.92157 2.31803ZM3.75 5.25H3C3 6.18543 3.4519 7.63729 4.43944 8.74827L5 8.25L5.56056 7.75173C4.81476 6.91271 4.5 5.81457 4.5 5.25H3.75ZM5 8.25L4.43944 8.74827C4.78739 9.13971 5.14435 9.97185 5.26158 10.6313L6 10.5L6.73842 10.3687C6.58899 9.52815 6.14595 8.41029 5.56056 7.75173L5 8.25ZM6 10.5V11.25H10V10.5V9.75H6V10.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.5 12.75H10.5",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25 15H9.75",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinejoin: "round"
		})
	]
});
export default SvgLight;
